import type { Organization } from './types';

/**
 * Whether the signed-in user manages this org (owner or admin) rather than
 * just using it — the split the server enforces on member, key, package and
 * settings changes. An unknown role (an older server that does not report one)
 * shows the controls and leaves the decision to the server.
 */
export function canManageOrg(org: Pick<Organization, 'role'> | null | undefined): boolean {
  return org?.role !== 'member';
}
